import { render, staticRenderFns } from "./PresentationKebabMenu.vue?vue&type=template&id=22052197&scoped=true&"
import script from "./PresentationKebabMenu.vue?vue&type=script&lang=js&"
export * from "./PresentationKebabMenu.vue?vue&type=script&lang=js&"
import style0 from "./PresentationKebabMenu.vue?vue&type=style&index=0&id=22052197&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22052197",
  null
  
)

export default component.exports